const MEDIA_ITEMS = [
  {
    id: 1,
    title: '都市夜未央',
    meta: '香蕉视频 · 都市情感 · 更新至28集',
    rating: '9.2',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20style%20composition%2C%20warm%20rose%20and%20gold%20color%20palette%2C%20sophisticated%20traditional%20elements%20with%20modern%20minimalist%20design%2C%20clean%20poster%20layout%2C%20dramatic%20portrait%20photography%20with%20soft%20warm%20lighting&width=400&height=560&seq=media-poster-01&orientation=portrait',
  },
  {
    id: 2,
    title: '暗影追踪者',
    meta: '糖豆视频 · 悬疑烧脑 · 全36集',
    rating: '9.5',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20style%2C%20warm%20amber%20tones%20with%20rose%20accents%2C%20city%20skyline%20silhouette%20background%2C%20elegant%20couple%20composition%2C%20clean%20contemporary%20poster%20design%20with%20soft%20cinematic%20lighting&width=400&height=560&seq=media-poster-02&orientation=portrait',
  },
  {
    id: 3,
    title: '江山万里图',
    meta: '蓝莓视频 · 古装历史 · 更新至42集',
    rating: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%20style%2C%20dramatic%20warm%20lighting%20with%20deep%20contrast%2C%20intense%20atmosphere%2C%20dynamic%20composition%2C%20clean%20modern%20poster%20design%20with%20warm%20golden%20and%20dark%20tones&width=400&height=560&seq=media-poster-03&orientation=portrait',
  },
  {
    id: 4,
    title: '幸福小区',
    meta: '小蓝视频 · 家庭喜剧 · 全48集',
    rating: '9.0',
    image: 'https://readdy.ai/api/search-image?query=Family%20comedy%20drama%20poster%20style%2C%20bright%20warm%20tones%20with%20soft%20rose%20accents%2C%20cheerful%20atmosphere%2C%20clean%20modern%20poster%20design%20with%20cozy%20home-like%20background%20elements%20and%20warm%20lighting&width=400&height=560&seq=media-poster-04&orientation=portrait',
  },
  {
    id: 5,
    title: '迷雾深渊',
    meta: '糖豆视频 · 悬疑惊悚 · 更新至16集',
    rating: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20suspense%20series%20poster%20style%2C%20moody%20warm%20amber%20lighting%2C%20enigmatic%20atmosphere%2C%20sophisticated%20dark%20tones%20with%20rose%20gold%20accents%2C%20clean%20dramatic%20poster%20design&width=400&height=560&seq=media-poster-05&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-3">
            正在热播
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">热播剧集</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            各平台最新热门剧集一键直达
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {MEDIA_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden bg-background-200/50">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-2 right-2 w-8 h-8 rounded-lg bg-background-50/90 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">{item.rating}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h3 className="text-sm font-medium text-background-50 mb-0.5">{item.title}</h3>
                  <p className="text-xs text-background-100/80">{item.meta}</p>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}